import React from "react"

import BookContent from "~components/pages/book/book-content"
import BookTripProvider from "~components/pages/book/book-trip-provider"
import WithAuthenticationRequired from "~components/shared/with-authentication-required"
import usePersistedGuestAccessToken from "~utils/use-persisted-guest-access-token"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"

interface Props {
    readonly quoteId: string | null
}

export default function BookTrip({ quoteId }: Props) {
    const { guestAccessToken } = usePersistedGuestAccessToken()
    const { isWidget } = useCheckoutFlow()

    // If the user has an access token, we don't require auth.
    // Guest checkout sessions will have a token but auth0 considers them unauthenticated.
    // We also don't require auth here for widgets, since we don't want to auto redirect to auth0.
    // If it's a widget session without auth (which shouldn't happen), we'll let the request error show.
    const isAuthRequired = !guestAccessToken && !isWidget

    return (
        <WithAuthenticationRequired isAuthRequired={isAuthRequired}>
            <BookTripProvider quoteId={quoteId}>
                <BookContent />
            </BookTripProvider>
        </WithAuthenticationRequired>
    )
}
